import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { LOCALIZE_NAME_OPTIONS } from "~/constans/commom";

import s from "./TableColumn.less";
import theme from "./themes.less";
import { getKeyFromOptionsTable } from "~/components/Table";

interface IProps {
  name: { key: string; handle: () => string } | string;
  nameChildren?: string[];
  nameColumnChildren?: string[];
  type: string;
  sortable: boolean;
  collSpanTh?: boolean;
  positionStiki?: boolean;
  noClick?: boolean;
  localizationName?: string;
  customTableHeaderClass?: string;
  borderRight?: string;
}

const TableColumn: React.FC<IProps> = ({
  name,
  type,
  nameChildren = [],
  nameColumnChildren = [],
  sortable,
  collSpanTh = false,
  positionStiki = false,
  noClick = false,
  localizationName,
  customTableHeaderClass = "",
  borderRight = "",
}) => {
  const { t } = useTranslation();
  const { sortField, sortType, searchTextForSelect } = useGetLocationData();
  let lang = localStorage.getItem("language");
  const setData = useSetLocationData();
  const setSort = (i, e) => {
    setData("sortType", i, "sortField", e);
  };
  const isColumnFile = name === "file";

  const arrNameEmployeeTraining = [
    "position",
    "dealer",
    "ladaAcademiaId",
    "fio",
  ];
  //employeeTraining
  const violation =
    type !== "violation" ||
    !["name", "statusTranslate"].includes(getKeyFromOptionsTable(name));

  const accounting =
    type !== "accounting" || !["Files"].includes(getKeyFromOptionsTable(name));

  const employee =
    type !== "employee" ||
    !["positions"].includes(getKeyFromOptionsTable(name));
  const commonName =
    type === "indicators" && name === "name"
      ? lang === "en"
        ? nameChildren[1]
        : nameChildren[0]
      : isColumnFile
      ? null
      : LOCALIZE_NAME_OPTIONS.includes(getKeyFromOptionsTable(name)) &&
        lang === "en"
      ? `${name}En`
      : name;

  const sort = () => {
    sortable &&
    sortField !== "mainEmailStatus" &&
    commonName !== "mainEmailStatus"
      ? sortField === commonName
        ? sortType === "ASC"
          ? setSort("DESC", commonName)
          : sortType === "DESC"
          ? setSort(undefined, undefined)
          : sortType === undefined && setSort("ASC", commonName)
        : setSort("ASC", commonName)
      : null;
  };

  return (
    <>
      <th
        className={clsx({
          [s.s_column]: sortable && sortField === commonName,
          [s.sortable]:
            sortable && !isColumnFile && violation && accounting && employee,
          [s.sortable]:
            sortable && !noClick && !isColumnFile && accounting && violation,
          [s.th_none]:
            collSpanTh &&
            getKeyFromOptionsTable(name) === "IndicatorYearPercent",
          [s.positionStiki]: positionStiki,
          [customTableHeaderClass]: !!customTableHeaderClass,
          [s.th_no_padding]:
            type === "srr" &&
            (nameColumnChildren.includes(getKeyFromOptionsTable(name)) ||
              searchTextForSelect ===
                "TOReturnCarForServiceByPeriodConsolidated"),
          [theme[`widthFor_${type}_${name}`.replace(".", "-")]]: true,
        })}
        colSpan={
          collSpanTh && getKeyFromOptionsTable(name) === "IndicatorYearValue"
            ? 2
            : 1
        }
        onClick={violation && accounting && employee && !noClick ? sort : null}
        style={{ borderRight: borderRight }}
      >
        <div>
          <span className={s.title}>
            {(type === "regMen" && Number(name)) ||
            (type === "employeeTraining" &&
              !arrNameEmployeeTraining.includes(getKeyFromOptionsTable(name)))
              ? getKeyFromOptionsTable(name)
              : typeof name === "string"
              ? t(`${localizationName || type}.${name}`)
              : name.handle()}
          </span>

          <span
            className={clsx({
              [s.triangle]: true,
              [s.triangle_asc]: sortable && sortType === "ASC",
              [s.triangle_desc]: sortable && sortType === "DESC",
            })}
          />
        </div>
      </th>
    </>
  );
};
export default TableColumn;
